export default async function getSessionResetPassword(basketId: string): Promise<void> {
  try {
    const queryParameter = `?basket_id=${encodeURIComponent(basketId)}`
    const url = `/customer-identity/single-sign-on/session/reset-password${queryParameter}`
    await fetch(url)
  } catch (error) {
    console.error(error)
  }
}
